import { useState } from "react"
import { ChartstwitsRepository } from "../../../repository/ChartstwitsRepository";
import { UserState } from "../../../store/UserState";
import { useNavigate } from "react-router-dom";

export function LoginModel(){

    const apiModel = ChartstwitsRepository();
    const navigate = useNavigate();
    const [login,setLogin]= useState({
        Email : '',
        Password : ''
    });

    const Login = () =>{
        debugger;
        apiModel.loginUser(login).then((result:any)=>{
            debugger;
            if(result.length>0)
            {
              
              
                navigate('/home');
                window.location.reload();
                
            }
        })
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        debugger;
        if ('value' in e.target) {
            debugger;
            const { name, value } = e.target as HTMLInputElement | HTMLTextAreaElement;
            setLogin((prev) => ({ ...prev, [name]: value }));
        } else {
            debugger;
            const { name, value } = e.target as HTMLSelectElement;
            setLogin((prev) => ({ ...prev, [name]: value }));
        }

      
    }

    return{login,Login,handleChange}
}